import Boundary from 'Components/Boundary';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';

ReactDOM.render(
    <Boundary>
        <App />
    </Boundary>,
    document.getElementById('root'),
);
